import Index from './pages/Index.vue'

export default [
    {
        path: '/sessions',
        name: 'sessions',
        meta: {
            title: 'Logs de acesso',
        },
        component: Index,
    },
]
